export const filterPanels = {
  backgroundColor: '#fff',
  diabledBackground: 'rgb(144, 144, 144);',
  disabledText: '#fff'
}
export default filterPanels
